module.exports = __webpack_public_path__ + "static/media/Murmuratto_Template_User.164d1234.csv";